export const GET_ASSESSMENT_INQUIRIES = "GET_ASSESSMENT_INQUIRIES";
export const GET_ASSESSMENT_INQUIRY_BY_ID = "GET_ASSESSMENT_INQUIRY_BY_ID";
export const UPDATE_ASSESSMENT_INQUIRY = "UPDATE_ASSESSMENT_INQUIRY";
export const DELETE_ASSESSMENT_INQUIRY = "DELETE_ASSESSMENT_INQUIRY";
export const CREATE_ASSESSMENT_INQUIRY = "CREATE_ASSESSMENT_INQUIRY";
